import { Calendar } from 'lucide-react';
import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { Label } from 'src/components/ui/label';

interface ExportDateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  exportDateRange: { start: string; end: string };
  onDateChange: (range: { start: string; end: string }) => void;
  onConfirm: () => void;
}

const ExportDateDialog = ({
  open,
  onOpenChange,
  exportDateRange,
  onDateChange,
  onConfirm,
}: ExportDateDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle>Select Date Range for Export</DialogTitle>
        <DialogDescription>
          Please select a date range to export sessions.
        </DialogDescription>
      </DialogHeader>
      <div className="grid gap-4 py-4">
        <div className="grid gap-2">
          <Label htmlFor="export-start-date">From Date</Label>
          <div className="relative">
            <Calendar className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#5B6B80] pointer-events-none" />
            <input
              id="export-start-date"
              type="date"
              value={exportDateRange.start}
              onChange={e =>
                onDateChange({ ...exportDateRange, start: e.target.value })
              }
              className="w-full pl-8 pr-2 py-2 border border-[#00387D] rounded text-sm focus:outline-none focus:ring-2 focus:ring-[#00387D]/20"
            />
          </div>
        </div>
        <div className="grid gap-2">
          <Label htmlFor="export-end-date">To Date</Label>
          <div className="relative">
            <Calendar className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#5B6B80] pointer-events-none" />
            <input
              id="export-end-date"
              type="date"
              value={exportDateRange.end}
              onChange={e =>
                onDateChange({ ...exportDateRange, end: e.target.value })
              }
              className="w-full pl-8 pr-2 py-2 border border-[#00387D] rounded text-sm focus:outline-none focus:ring-2 focus:ring-[#00387D]/20"
            />
          </div>
        </div>
      </div>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={() => {
            onOpenChange(false);
            onDateChange({ start: '', end: '' });
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={!exportDateRange.start || !exportDateRange.end}
        >
          Export
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ExportDateDialog;
